/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CourseEntity } from '../models/CourseEntity';
import type { PublicCourseGroupWithBookingInfoEntity } from '../models/PublicCourseGroupWithBookingInfoEntity';
import type { PublicCourseWithPriceDetailsEntity } from '../models/PublicCourseWithPriceDetailsEntity';
import type { PublicInstructorEntity } from '../models/PublicInstructorEntity';
import type { PublicMediaGalleryItemEntity } from '../models/PublicMediaGalleryItemEntity';
import type { PublicMeetingWithBookingInfoEntity } from '../models/PublicMeetingWithBookingInfoEntity';
import type { PublicMultipassProductEntity } from '../models/PublicMultipassProductEntity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class CoursePublicService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all Courses
     * @param organizationId
     * @param tagId
     * @returns PublicCourseWithPriceDetailsEntity Courses have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCoursesV1(
        organizationId: string,
        tagId?: string,
    ): CancelablePromise<Array<PublicCourseWithPriceDetailsEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course',
            query: {
                'organizationId': organizationId,
                'tagId': tagId,
            },
        });
    }
    /**
     * Get a single course by id
     * @param courseId
     * @returns CourseEntity The course has been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseV1(
        courseId: string,
    ): CancelablePromise<CourseEntity> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}',
            path: {
                'courseId': courseId,
            },
        });
    }
    /**
     * Get all Media Gallery Items of a Course
     * @param courseId
     * @returns PublicMediaGalleryItemEntity Media Gallery Items have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseMediaGalleryItemsV1(
        courseId: string,
    ): CancelablePromise<Array<PublicMediaGalleryItemEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/mediaGalleryItems',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get all ungrouped Meetings of a Course including their Booking info
     * @param courseId
     * @param orderId
     * @returns PublicMeetingWithBookingInfoEntity Course Meetings have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseMeetingsV1(
        courseId: string,
        orderId?: string,
    ): CancelablePromise<Array<PublicMeetingWithBookingInfoEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/meetings',
            path: {
                'courseId': courseId,
            },
            query: {
                'orderId': orderId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get all Course Groups of a Course including their Booking info
     * @param courseId
     * @returns PublicCourseGroupWithBookingInfoEntity Course Groups have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseGroupsV1(
        courseId: string,
    ): CancelablePromise<Array<PublicCourseGroupWithBookingInfoEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/courseGroups',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get the instructors of a course
     * @param courseId
     * @returns PublicInstructorEntity Course Instructors has been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseInstructorV1(
        courseId: string,
    ): CancelablePromise<Array<PublicInstructorEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/instructor',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get a list of instructors that instruct upcoming meetings
     * @param courseId
     * @returns PublicInstructorEntity Meeting Instructors have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetUpcomingMeetingInstructorsV1(
        courseId: string,
    ): CancelablePromise<Array<PublicInstructorEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/upcomingMeetingInstructors',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get all publicly visible multipass products eligible for a course
     * @param courseId
     * @returns PublicMultipassProductEntity Multipass products have been returned
     * @throws ApiError
     */
    public coursePublicControllerGetCourseMultipassProductsV1(
        courseId: string,
    ): CancelablePromise<Array<PublicMultipassProductEntity>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/multipassProducts',
            path: {
                'courseId': courseId,
            },
            errors: {
                404: `Course has not been found`,
            },
        });
    }
    /**
     * Get live server-sent-events (SSE) about the Meetings of a Course including their Booking info
     * @param courseId
     * @returns any
     * @throws ApiError
     */
    public coursePublicControllerGetCourseMeetingEventsV1(
        courseId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/public/course/{courseId}/meetings/changes',
            path: {
                'courseId': courseId,
            },
        });
    }
}
